/* glb-header.js — WS-GLOBAL: Shop mega menu (desktop) + Shop accordion (mobile drawer). Vanilla, no libraries. */
(function () {
  'use strict';
  var hoverOK = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');

  function initDesktop() {
    var item = document.querySelector('[data-glb-nav-shop]');
    var panel = document.getElementById('glb-mega-panel');
    if (!item || !panel || item.__glb) return;
    item.__glb = true;
    var btn = item.querySelector('.glb-nav-toggle');
    var link = item.querySelector('a');
    var timer = null;

    function visible() { return btn.offsetParent !== null; }
    function open() {
      if (!visible()) return;
      clearTimeout(timer);
      if (!panel.hidden) return;
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      item.classList.add('is-open');
      document.documentElement.classList.add('glb-mega-open');
    }
    function close(returnFocus) {
      clearTimeout(timer);
      if (panel.hidden) return;
      panel.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      item.classList.remove('is-open');
      document.documentElement.classList.remove('glb-mega-open');
      if (returnFocus) btn.focus();
    }
    function later() { clearTimeout(timer); timer = setTimeout(function () { close(false); }, 180); }

    btn.addEventListener('click', function () { panel.hidden ? open() : close(false); });
    [item, panel].forEach(function (el) {
      el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') open(); });
      el.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') later(); });
    });
    link.addEventListener('focus', function () { /* keyboard users open with the button, not by tabbing past */ });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) { close(true); }
    });
    document.addEventListener('click', function (e) {
      if (panel.hidden) return;
      if (item.contains(e.target) || panel.contains(e.target)) return;
      close(false);
    });
    panel.addEventListener('focusout', function (e) {
      if (!panel.hidden && e.relatedTarget && !panel.contains(e.relatedTarget) && !item.contains(e.relatedTarget)) close(false);
    });
    window.addEventListener('resize', function () { if (!visible()) close(false); });
  }

  function initMobile() {
    document.querySelectorAll('[data-glb-m-trigger]').forEach(function (t) {
      if (t.__glb) return;
      t.__glb = true;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (!panel) return;
      t.addEventListener('click', function (e) {
        e.preventDefault();
        var open = t.getAttribute('aria-expanded') === 'true';
        t.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
        t.closest('.glb-m').classList.toggle('is-open', !open);
      });
    });
  }

  function init() { initDesktop(); initMobile(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
